import { LegacyGatewayBase } from './base'
import { toAuthProps } from './translator/auth'
import { toUserProps } from './translator/user'
import { toLoginRequest } from './translator/login'
import { IAccountProps } from '@/entities/Account'
import { Login, Refresh, Me, Logout } from '@/infrastructure/network/Legacy/requests/auth'

export default class Auth extends LegacyGatewayBase {
  async Login(params: IAccountProps) {
    const { login } = await this.apiClient.request(new Login(toLoginRequest(params)))
    return toAuthProps(login)
  }

  async Refresh() {
    const { login } = await this.apiClient.request(new Refresh())
    return toAuthProps(login)
  }

  async Me() {
    const { me } = await this.apiClient.request(new Me())
    return toUserProps(me)
  }

  async Logout() {
    const { logout } = await this.apiClient.request(new Logout())
    return !!logout
  }
}
